<template>
  <v-container grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12>
        <div style="min-height: 310px;">
        <v-autocomplete label="Seleccione Categoría" :items="categories" v-model="category" item-text="name" return-object v-if="category.name !== 'Nueva Categoría'"></v-autocomplete>
        <v-text-field ref="categorySelect" v-model="newCategory" v-else :autofocus="true" label="Especifique Nueva Categoría" append-icon="fas fa-times" @click:append="dismissCategory"></v-text-field>
        <template v-if="category">
          <v-text-field :autofocus="category.name === 'Nueva Categoría' ? false : true" v-model="newService" v-if="service && service.serviceItem === 'Nuevo'" label="Especifique Nuevo Servicio" append-icon="fas fa-times" @click:append="dismissService"></v-text-field>
          <v-autocomplete label="Seleccione Servicio" v-else  v-model="service" :items="services" item-text="serviceItem" return-object></v-autocomplete>
          <template v-if="service">
            <v-checkbox true-value="1" false-value="0" color="primary" label="Este servicio se puede agendar" class="mt-0" v-model="schedulable"></v-checkbox>
            <v-checkbox v-if="mustQuote" color="primary" label="Este servicio se puede cotizar" class="mt-0" v-model="quotable" :disabled="true"></v-checkbox>
            <v-checkbox v-else color="primary" label="Este servicio se puede cotizar" class="mt-0" v-model="quotable"></v-checkbox>
            <v-checkbox v-if="quotable" color="primary" label="No posee Impuesto" class="mt-0" v-model="taxFree"></v-checkbox>
            <v-text-field id="money" label="Especifique valor del Servicio" :autofocus="quotable" v-model.lazy="servicePrice" v-money="money" :disabled="!quotable"></v-text-field>
          </template>
        </template>
        </div>
      </v-flex>
      <v-flex xs12>
        <div class="text-right">
          <v-btn color="secondary" dark @click="resetAndClose">Cancelar</v-btn>
          <v-btn :loading="adding" color="primary" :disabled="agreeDisabled" @click="sendData">Agregar</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { ApiUtils } from '@/utils/ApiUtils'
import { VMoney } from 'v-money'
export default {
  props: {
    mustQuote: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // categories: [],
      category: '',
      newCategory: '',
      services: [],
      service: '',
      newService: '',
      addedServices: [],
      schedulable: 0,
      quotable: false,
      taxFree: false,
      servicePrice: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 0,
        masked: false /* doesn't work with directive */
      },
      adding: false
    }
  },
  watch: {
    category: function(val) {
      if (val) {
        this.service = null
        this.schedulable = 0
        this.quotable = false
        this.ServicePrice = 0
        this.newService = ''
        const services = this.$store.getters['services/servicesByCategory'](val.categoryId)
        this.services = [
          {serviceItem: 'Nuevo', serviceItemId: null},
          ...services
        ]
        if (val.name === 'Nueva Categoría') {
          this.service = {serviceItem: 'Nuevo', serviceItemId: null}
        }
        this.quotable = this.mustQuote
      } else {
        this.services = []
      }
    },
    quotable: function(val) {
      if (val) {
        this.ServicePrice = 0
        this.moneyReset()
      } else {
        this.moneyReset()
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('services/loadServices')
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser
    },
    categories() {
      const categories = this.$store.getters['services/categories']
      return [
        {name: 'Nueva Categoría', id: null},
        ...categories.sort((a, b) => a.categoryId - b.categoryId)
      ]
    },
    agreeDisabled() {
      if(
        (!this.category && !this.newCategory) || (!this.service && !this.newService) || (this.quotable && this.servicePrice.length <= 1)
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    reset() {
      this.category = ''
      this.service = ''
      this.newCategory = ''
      this.newService = ''
      this.schedulable = 0
      this.quotable = false
      this.taxFree = false
      this.ServicePrice = 0
    },
    moneyReset() {
      const money = document.getElementById('money')
      money.value = "0"
    },
    resetAndClose() {
      this.reset()
      this.$emit('close')
    },
    dismissCategory() {
      this.category = ''
      this.newCategory = ''
    },
    dismissService() {
      this.service = ''
      this.newService = ''
    },
    async sendData() {
      if (this.newCategory === 'Nueva Categoría' || this.newService === 'Nuevo') {
        this.$store.commit('showSnackBar', 'Nombre no permitido')
        return
      }
      const userId = this.currentUser.service_providers[0].id
      const isNewCategory = this.category.name === 'Nueva Categoría'
      const isNewService = this.service.serviceItem === 'Nuevo'

      const serviceItem = {
        description: isNewService ? this.newService : this.service.serviceItem,
        service_item_id: isNewService ? null : this.service.serviceItemId,
        quotable: this.quotable ? 1 : 0,
        schedulable: this.schedulable,
        auto_attach: 1,
        tax_free: this.taxFree ? 1 : 0,
        price: this.quotable ? Number(this.servicePrice.replace(/[.]/g, '')) : 0
      }
      if (this.mustQuote)
        serviceItem.quotable = 1
      const category = {
        name: isNewCategory ? this.newCategory : this.category.name,
        id: isNewCategory ? null : this.category.categoryId,
        service_items: []
      }
      let url = ''
      let payload = null
      if (isNewCategory) {
        category.service_items.push(serviceItem)
        // send new category and service
        url = `provider/${userId}/service`
        payload = category

      } else if (!isNewCategory && isNewService) {
        // send only new service
        url = `provider/${userId}/service/${category.id}/item`
        payload = serviceItem
        // delete payload.service_item_id
      } else if (!isNewCategory && !isNewService) {
        // atach service to provider
        url = `provider/${userId}/service/item/attach`
        payload = serviceItem
      }
      //
      // return
      this.adding = true
      let response = null
      try {
        response = await ApiUtils.makePost(url, payload)
      } catch (error) {

      }
      if (response.ok) {
        const responseData = await response.json()
        const result = responseData.result.service
        let pushPayloadService = {}
        if (isNewCategory) {
          const pushPayloadCategory = {
            categoryId: result.id,
            name: result.name,
          }
          pushPayloadService = {
            categoryId: result.id,
            categoryName: result.name,
            serviceItem: result.service_items[0].description,
            serviceItemId: result.service_items[0].id,
            quotable: serviceItem.quotable,
            taxFree: serviceItem.tax_free || 0,
            schedulable: serviceItem.schedulable || 0,
            price: serviceItem.price || 0,
            reviewed: 0
          }
          this.$store.commit('services/addProviderCategory', pushPayloadCategory)
          this.$store.commit('services/addProviderService', pushPayloadService)
        } else if (!isNewCategory && isNewService) {
          pushPayloadService = {
            categoryId: category.id,
            categoryName: category.name,
            serviceItem: responseData.result.service_item.description,
            serviceItemId: responseData.result.service_item.id,
            quotable: serviceItem.quotable,
            taxFree: serviceItem.tax_free || 0,
            schedulable: serviceItem.schedulable || 0,
            price: serviceItem.price || 0,
            reviewed: 0
          }

          this.$store.commit('services/addProviderService', pushPayloadService)
        } else if (!isNewCategory && !isNewService) {
          pushPayloadService = {
            categoryId: category.id,
            categoryName: category.name,
            serviceItem: serviceItem.description,
            serviceItemId: serviceItem.service_item_id,
            quotable: serviceItem.quotable,
            taxFree: serviceItem.tax_free || 0,
            schedulable: serviceItem.schedulable || 0,
            price: serviceItem.price || 0,
            reviewed: 1
          }

          this.$store.commit('services/addProviderService', pushPayloadService)
        }
        //
        const emitValue = {
          id: pushPayloadService.serviceItemId,
          description: {
            serviceItemId: pushPayloadService.serviceItemId,
            serviceId: pushPayloadService.categoryId,
            serviceName: pushPayloadService.categoryName,
            description: pushPayloadService.serviceItem,
            fullName: pushPayloadService.categoryName + ' | ' + pushPayloadService.serviceItem
          },
          price: pushPayloadService.price || 0,
          discount: 0,
          qty: 1,
          taxFree: serviceItem.tax_free || 0
        }

        this.$emit('added', emitValue)
        //
        this.$store.commit('showSnackBar', 'Servicio Añadido')
        this.resetAndClose()
      } else {
        const responseData = await response.json()
        this.$store.commit('showSnackBar', responseData.message)
      }
      this.adding = false
    }
  },
}
</script>

<style scoped>
.services-list {
  border: 1px solid rgb(165, 165, 165);
}
</style>
